var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action-button",style:(_vm.buttonType == 'positive'
      ? {
          color: this.guestBookForm.textColor,
          'background-color': this.guestBookForm.formColor,
        }
      : {
          color: '#AAAAAA',
          border: 'solid 2px #AAAAAA',
          'background-color': 'transparent',
        }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('emitEvent')}}},[_vm._v(" "+_vm._s(_vm.buttonText.toUpperCase())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }